<template>
  <div>
    <TextMetadata
      :isLineItem="isLineItem"
      :textSelection="textSelection"
      :focusOnLoad="focusOnLoad"
      :documentMetadata="documentMetadata"
      :onClickToFill="onClickToFill"
      @update:value="updateMetadataValue"
      @update:property="updateMetadataProperty"
      v-if="isMatch([metadataType.Text, metadataType.TextArea])"
    />
    <NumericMetadata
      :isLineItem="isLineItem"
      :textSelection="textSelection"
      :focusOnLoad="focusOnLoad"
      :documentMetadata="documentMetadata"
      :onClickToFill="onClickToFill"
      @update:value="updateMetadataValue"
      @update:property="updateMetadataProperty"
      v-if="isMatch([metadataType.Currency, metadataType.Numeric])"
    />
    <PartyMetadata
      :isLineItem="isLineItem"
      :textSelection="textSelection"
      :focusOnLoad="focusOnLoad"
      :documentMetadata="documentMetadata"
      :onClickToFill="onClickToFill"
      :partyTypeId="partyTypeId"
      :onPartyChanged="onPartyChanged"
      @update:value="updateMetadataValue"
      @update:property="updateMetadataProperty"
      v-if="
        isMatch([
          metadataType.Vendor,
          metadataType.Bank,
          metadataType.Operator,
          metadataType.Owner,
          metadataType.Purchaser,
        ])
      "
    />
    <CompanyMetadata
      :documentMetadata="documentMetadata"
      @update:value="updateMetadataValue"
      @update:property="updateMetadataProperty"
      v-if="isMatch(metadataType.Company)"
    />
    <DateMetadata
      :isLineItem="isLineItem"
      :textSelection="textSelection"
      :focusOnLoad="focusOnLoad"
      :documentMetadata="documentMetadata"
      :onClickToFill="onClickToFill"
      @update:value="updateMetadataValue"
      @update:property="updateMetadataProperty"
      v-if="isMatch(metadataType.Date)"
    />
    <DateTimeMetadata
      :isLineItem="isLineItem"
      :textSelection="textSelection"
      :focusOnLoad="focusOnLoad"
      :documentMetadata="documentMetadata"
      :onClickToFill="onClickToFill"
      @update:value="updateMetadataValue"
      @update:property="updateMetadataProperty"
      v-if="isMatch(metadataType.DateTime)"
    />
    <OrgUnitMetadata
      :isLineItem="isLineItem"
      :textSelection="textSelection"
      :focusOnLoad="focusOnLoad"
      :documentMetadata="documentMetadata"
      :onClickToFill="onClickToFill"
      @update:value="updateMetadataValue"
      @update:property="updateMetadataProperty"
      v-if="isMatch(metadataType.OrgUnit)"
    />
    <ListMetadata
      :isLineItem="isLineItem"
      :textSelection="textSelection"
      :focusOnLoad="focusOnLoad"
      :documentMetadata="documentMetadata"
      :onClickToFill="onClickToFill"
      @update:value="updateMetadataValue"
      @update:property="updateMetadataProperty"
      v-if="isMatch(metadataType.List)"
    />
  </div>
</template>

<script>
import metadataType from "@/constants/metadataType";
import partyType from "@/constants/partyType";
import TextMetadata from "@/components/metadata/TextMetadata.vue";
import NumericMetadata from "@/components/metadata/NumericMetadata.vue";
import PartyMetadata from "@/components/metadata/PartyMetadata.vue";
import DateMetadata from "@/components/metadata/DateMetadata.vue";
import OrgUnitMetadata from "@/components/metadata/OrgUnitMetadata.vue";
import ListMetadata from "@/components/metadata/ListMetadata.vue";
import DateTimeMetadata from "@/components/metadata/DateTimeMetadata.vue";
import CompanyMetadata from "./metadata/CompanyMetadata.vue";

const metadataTypeToParty = {};
metadataTypeToParty[metadataType.Vendor] = partyType.VENDOR;
metadataTypeToParty[metadataType.Bank] = partyType.BANK;
metadataTypeToParty[metadataType.Operator] = partyType.OPERATOR;
metadataTypeToParty[metadataType.Owner] = partyType.OWNER;
metadataTypeToParty[metadataType.Purchaser] = partyType.PURCHASER;

export default {
  name: "DocumentMetadata",
  props: {
    documentMetadata: Object,
    textSelection: Object,
    isLineItem: Boolean,
    focusOnLoad: Boolean,
    onClickToFill: Function,
    onPartyChanged: Function,
  },
  components: {
    CompanyMetadata,
    TextMetadata,
    NumericMetadata,
    PartyMetadata,
    DateMetadata,
    OrgUnitMetadata,
    ListMetadata,
    DateTimeMetadata,
  },
  data() {
    return {
      metadataType,
    };
  },

  computed: {
    partyTypeId() {
      return metadataTypeToParty[this.documentMetadata.metadata.metadataType.id];
    },
  },

  methods: {
    isMatch(args) {
      if (!this.documentMetadata) return false;

      let ids = Array.isArray(args) ? args : [args];
      let mtId = this.documentMetadata.metadata.metadataType.id;
      return ids.includes(mtId);
    },

    /**
     * Handle value updates from child metadata components
     * This is where we perform the mutation, keeping it close to the data source
     * @param {*} value - The new value for documentMetadata.value
     */
    updateMetadataValue(value) {
      // We perform the mutation here at the parent level
      // This is acceptable in Vue 2 for object properties as it maintains reactivity
      // eslint-disable-next-line vue/no-mutating-props
      this.documentMetadata.value = value;
    },

    /**
     * Handle property updates from child metadata components
     * @param {Object} payload - Object containing property name and value
     * @param {string} payload.property - The property name to update
     * @param {*} payload.value - The new value for the property
     */
    updateMetadataProperty({ property, value }) {
      // eslint-disable-next-line vue/no-mutating-props
      this.documentMetadata[property] = value;
    },
  },
};
</script>
<style>
.metadata-label {
  color: rgba(var(--v-theme-on-surface), 0.6);
  font-size: 12px;
  margin-bottom: 2px;
}
</style>
